import { IRequestContext } from '@msdyn365-commerce/core';
import { useCallback, useEffect } from 'react';
import { useCookieService } from '../services/cookie-service/hooks/use-cookie-service';
import { UserCentricsService } from '../../integrations/userCentrics/UserCentricsService';

export const useConsentCookieSync = (request: IRequestContext) => {
    const cookieService = useCookieService(request);

    const syncConsentCookies = useCallback(async () => {
        await cookieService.syncMsdynUserConsentCookie();
        await cookieService.syncConsentGatedCookies();
    }, [cookieService]);

    useEffect(() => {
        return UserCentricsService.subscribeToUCInitialized(syncConsentCookies);
    }, [syncConsentCookies]);
};
